module.exports = __webpack_public_path__ + "static/media/ju4.9e804dda.jpg";